var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property } from 'lit/decorators.js';
/**
 * An option for the kr-select-field component.
 *
 * @element kr-select-option
 * @slot - The option label content
 */
export class KRSelectOption extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * The option value
         */
        this.value = '';
        /**
         * Whether the option is disabled
         */
        this.disabled = false;
    }
    /** Gets the label text from the slot */
    get label() {
        return this.textContent?.trim() || '';
    }
    render() {
        return html `<slot></slot>`;
    }
}
KRSelectOption.styles = css `
    :host {
      display: none;
    }
  `;
__decorate([
    property({ type: String })
], KRSelectOption.prototype, "value", void 0);
__decorate([
    property({ type: Boolean })
], KRSelectOption.prototype, "disabled", void 0);
// Guarded registration: no-op if the tag is already defined, so a second copy of krubble on
// the page (e.g. the Operations shell loads krubble globally while an embedded app bundled its
// own copy) doesn't throw. First definition wins.
if (!customElements.get('kr-select-option')) {
    customElements.define('kr-select-option', KRSelectOption);
}
//# sourceMappingURL=select-option.js.map